import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CCard, CCardGroup } from "@coreui/react";
import { toast } from "react-toastify";
import { useTranslationContext } from "@/context/TranslationContext";
import ServiceCategoryForm from "../serviceCategoryForm";
import { serviceCategory } from "@/constants/translation/serviceCategory.translation";
import { breadcrumb_key, messages } from "@/constants/translation/common.translation";
import ServiceCategoryValidationClass from "@/helpers/validations/serviceCategory";
import { masters } from "@/libs/routes";
import { useAddServiceCategory } from "@/hooks/useServiceCategory";

/**
 * Component for adding a new service category.
 * @returns {JSX.Element} The rendered AddServiceCategory component.
 */
const AddServiceCategory = () => {
  const t = useTranslationContext();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { mutate: doAddServiceCategory } = useAddServiceCategory(
    (response) => {
      toast.success(response?.message || t(messages.toast.serviceCategory.added));
      navigate(masters.serviceCategory.list);
    },
    (error) => {
      toast.error(error?.response?.data?.message || t(messages.toast.serviceCategory.addFailed));
      setIsSubmitting(false);
    }
  );

  const handleAddServiceCategory = (values) => {
    setIsSubmitting(true);
    doAddServiceCategory({ name: values.name, name_de: values.name_de });
  };

  const initialValues = useMemo(
    () => ({
      name: "",
      name_de: "",
    }),
    []
  );

  const validationSchema = useMemo(() => ServiceCategoryValidationClass.serviceCategoryValidation(t), [t]);

  return (
    <CCardGroup>
      <CCard className="p-4">
        <h1 className="text-center">{t(serviceCategory.add.main_heading)}</h1>
        <ServiceCategoryForm
          initialValues={initialValues}
          onSubmit={handleAddServiceCategory}
          isSubmitting={isSubmitting}
          validationSchema={validationSchema}
        />
      </CCard>
    </CCardGroup>
  );
};

AddServiceCategory.breadCrumbArray = [
  {
    name: breadcrumb_key.masters?.serviceCategory?.list,
    pathname: masters.serviceCategory.list,
    active: false,
  },
  {
    name: breadcrumb_key.masters?.serviceCategory?.add,
    pathname: masters.serviceCategory.add,
    active: true,
  },
];

export default AddServiceCategory;
